export const socialsData = {
    github: 'https://wa.me/+62895600394345',
    facebook: 'https://wa.me/+62895600394345',
    linkedIn: 'https://wa.me/+62895600394345',
    instagram: 'https://wa.me/+62895600394345',
    codepen: 'https://wa.me/+62895600394345',
    twitter: 'https://wa.me/+62895600394345',
    reddit: 'https://wa.me/+62895600394345',
    blogger: 'https://wa.me/+62895600394345',
    medium: 'https://wa.me/+62895600394345',
    stackOverflow: 'https://wa.me/+62895600394345',
    gitlab: 'https://wa.me/+62895600394345',
    youtube: 'https://wa.me/+62895600394345'
}